export enum ConclusionTypes {
	'Por Preenchimento' = 1,
	'Por Aprovação' = 2,
	'Por Sinalização' = 3,
	'Por Análise' = 4,
}

export enum ConclusionTypesTranslation {
	"by_filling"= 1,
	"by_approval"= 2,
	"by_signaling"= 3,
	"by_analisy"= 4
}

export enum AnalisyStatusTranslation {
	"send_to_analisy" = 1,
	"with_restriction" = 2,
	"finished_analisy" = 3,
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/enum/conclusion-type.ts